/** Upload-specific copy is isolated from the legacy asset-library translations. */
export const assetUploadCopy = {
  en: {
    uploadQueue: {
      title: 'File uploads',
      subtitle: '{{active}} active · {{total}} total',
      destination: 'Upload to folder',
      root: 'Unfiled (Root)',
      choose: 'Choose files',
      addMore: 'Add more files',
      drop: 'Drop files here, or choose from your device',
      helper: 'Images, video, audio, PDF, text, JSON and 3D models',
      queueLabel: 'Asset upload queue',
      fileProgress: 'Upload progress for {{name}}',
      cancel: 'Cancel upload',
      retry: 'Try again',
      dismiss: 'Remove from list',
      clearFinished: 'Clear finished',
      close: 'Close',
      toFolder: 'Destination: {{name}}',
      size: '{{value}} MB',
      processingHelp: 'Upload completed. Media processing runs on the server.',
      folderFailure: 'Uploaded, but could not place this asset in the selected folder. It is in Unfiled. Retry moving it.',
      delayed: 'Processing status could not be confirmed. The server may still be working; check again.',
      failed: 'Upload failed. Check the file or connection and try again.',
      cancelled: 'Upload cancelled before finalization.',
      activeWarning: 'Leaving this page cancels active browser uploads.',
      status: {
        queued: 'Queued',
        preparing: 'Preparing',
        uploading: 'Uploading · {{percent}}%',
        finalizing: 'Finalizing',
        filing: 'Moving to folder',
        processing: 'Processing',
        ready: 'Ready',
        failed: 'Failed',
        cancelled: 'Cancelled',
        'folder-failed': 'Folder move failed',
        'processing-failed': 'Processing failed',
        'processing-delayed': 'Checking delayed',
      },
    },
  },
  fa: {
    uploadQueue: {
      title: 'آپلود فایل‌ها',
      subtitle: '{{active}} فعال · {{total}} فایل',
      destination: 'فولدر مقصد',
      root: 'بدون فولدر (ریشه)',
      choose: 'انتخاب فایل‌ها',
      addMore: 'افزودن فایل‌های بیشتر',
      drop: 'فایل‌ها را اینجا رها کنید یا از دستگاه انتخاب کنید',
      helper: 'تصویر، ویدئو، صدا، PDF، متن، JSON و مدل سه‌بعدی',
      queueLabel: 'صف آپلود فایل‌ها',
      fileProgress: 'پیشرفت آپلود {{name}}',
      cancel: 'لغو آپلود',
      retry: 'تلاش دوباره',
      dismiss: 'حذف از فهرست',
      clearFinished: 'پاک کردن موارد پایان‌یافته',
      close: 'بستن',
      toFolder: 'مقصد: {{name}}',
      size: '{{value}} مگابایت',
      processingHelp: 'ارسال کامل شد؛ پردازش رسانه در سرور ادامه دارد.',
      folderFailure: 'فایل آپلود شده اما انتقال به فولدر انجام نشد. فایل در ریشه است. انتقال را دوباره امتحان کنید.',
      delayed: 'وضعیت پردازش تأیید نشد. ممکن است پردازش سرور ادامه داشته باشد؛ دوباره بررسی کنید.',
      failed: 'آپلود ناموفق بود. فایل یا اتصال را بررسی و دوباره امتحان کنید.',
      cancelled: 'آپلود پیش از نهایی‌سازی لغو شد.',
      activeWarning: 'خروج از این صفحه، آپلودهای فعال مرورگر را متوقف می‌کند.',
      status: {
        queued: 'در صف',
        preparing: 'آماده‌سازی',
        uploading: 'در حال ارسال · {{percent}}٪',
        finalizing: 'ثبت نهایی',
        filing: 'انتقال به فولدر',
        processing: 'در حال پردازش',
        ready: 'آماده',
        failed: 'ناموفق',
        cancelled: 'لغوشده',
        'folder-failed': 'خطای انتقال به فولدر',
        'processing-failed': 'خطای پردازش',
        'processing-delayed': 'تأخیر در بررسی',
      },
    },
  },
} as const;
